const CodeErrorTemplate = (p) => {

    function renderMessages(message) {
        var keys = null
        if (typeof message == 'string') {
            return message;
        }
        if (keys = Object.keys(message)) {
            return <dl>{keys.map((key) => {

                //console.log(message[key] );
                return (
                    <div>
                        <dt key={`dt-${key}`}>{key}</dt>
                        {
                            Array.isArray(message[key]) ?
                                message[key].map(value => <dd key={`dd-${key}`}>{(typeof value == 'object') ? renderMessages(value) : value}</dd>) :
                                <dd key={`dd-${key}`}>{message[key]}</dd>
                        }
                    </div>
                );
            })}</dl>;
        }
    }
    return (
        <div className='CodeError'>
            {/*<div className='CodeError_header'></div>*/}
            <div className='CodeError_body'>
                <div className='CodeError_message'>
                    {renderMessages(p.message)}
                </div>
            </div>
        </div>
    );
};

export default CodeErrorTemplate;